import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const useEmitterConfigurationUnit = (): {
  unit: string
  isImperial: boolean
  dbUnitPerHour: 'INCH' | 'MILLIMETER'
  emitterFlowRateUnit: string
  emitterSpacingUnit: string
  rowSpacingUnit: string
  min: number
  precision: number
} => {
  const rainUnit = userDetailsStore.useSelector((s) => s.rain)

  if (rainUnit === 'IMPERIAL') {
    return {
      unit: unitConverter.irrigationApplicationRate(null, { outputUnit: 'in' }).suffix(),
      emitterFlowRateUnit: unitConverter.emitterFlowRate(null, { outputUnit: 'gal/h' }).suffix(),
      emitterSpacingUnit: unitConverter.emitterSpacing(null, { outputUnit: 'in' }).suffix(),
      rowSpacingUnit: unitConverter.rowSpacing(null, { outputUnit: 'ft' }).suffix(),
      dbUnitPerHour: 'INCH',
      isImperial: true,
      min: 0.001,
      precision: 4,
    }
  }

  return {
    unit: unitConverter.irrigationApplicationRate(null, { outputUnit: 'mm' }).suffix(),
    emitterFlowRateUnit: unitConverter.emitterFlowRate(null, { outputUnit: 'l/h' }).suffix(),
    emitterSpacingUnit: unitConverter.emitterSpacing(null, { outputUnit: 'mm' }).suffix(),
    rowSpacingUnit: unitConverter.rowSpacing(null, { outputUnit: 'm' }).suffix(),
    dbUnitPerHour: 'MILLIMETER',
    isImperial: false,
    min: 0.01,
    precision: 3,
  }
}
